import { AuthUserEntity } from './../../types/AuthUser';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn:'root'
})
export class UserDetailService {
  public isSuperUserLoggedIn:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public _loggeedOnUserSubject= new BehaviorSubject<AuthUserEntity|null>(null);

  public loggedOnUserDetails$:Observable<AuthUserEntity|null>;

  constructor() { 
    this.loggedOnUserDetails$ = this._loggeedOnUserSubject.asObservable();
  }

  setUserDetails(userDetails:AuthUserEntity|null){
    this._loggeedOnUserSubject.next(userDetails);
  }

}
